type AtLeastOneArray<T> = { 0: T } & T[];

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const isAtLeastOneArray = <T extends unknown>(
    items: T | T[]
): items is AtLeastOneArray<T> => {
    if (!Array.isArray(items)) return false;
    return items.length > 0;
};

export type { AtLeastOneArray };
export { isAtLeastOneArray };
